import { render, staticRenderFns } from "./WilsonMicai.vue?vue&type=template&id=05067fbf"
import script from "./WilsonMicai.vue?vue&type=script&lang=js"
export * from "./WilsonMicai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports